<template>
    <div>
        <div class="modal-header py-0 d-flex flex-column crm-modal-header">
            <div class="row w-100">
                <div class="col-12 pt-3 pb-1 pr-0 d-flex justify-content-center align-items-center dNone">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{this.listenStateStatus?$ml.get("EDIT_PRODUCT"):$ml.get("ADD_PRODUCT")}}</h5>
                    <button type="button" @click="closeButton"  class="close "  aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                    </button>
                </div>
            </div>
            <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="product-tab" data-toggle="tab" href="#product" role="tab" aria-controls="product" aria-selected="true">{{$ml.get('DETAIL_PRODUCT')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="customField-tab" data-toggle="tab" href="#customField" role="tab" aria-controls="customField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                </li>
            </ul>
            <button type="button" class="close d-none" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
            </button>
        </div>
        <div class="modal-body pt-3 pb-2 px-md-4 crm-modal-body">
            <div class="tab-content">
                <div class="tab-pane fade show active py-2" id="product" role="tabpanel" aria-labelledby="product-tab">
                    <div class="row">
                        <div class="col-12 d-flex align-items-baseline crmButonGroupsType">
                            <!-- PRODUCT_STATUS -->
                            <!-- <label class="new-label">{{$ml.get('PASSIVE')}} / {{$ml.get('ACTIVE')}}</label>
                            <div class="d-flex align-items-center">
                                <label class="switch heightSwitch m-0">
                                <input type="checkbox"  v-model="status">
                                <span class="slider round true"></span>
                                </label>
                            </div> -->

                            <label class="new-label pr-4">{{$ml.get('PRODUCT_STATUS')}}</label>
                            <div class="btn-group">
                            <button class="btn btn-click h40 " @click="status=true" :class="{active:status==true}" style="border-radius:4px 0px 0px 4px">{{$ml.get('ACTIVE')}}</button>
                            <button class="btn btn-click h40" @click="status=false" :class="{active:status==false}" >{{$ml.get('PASSIVE')}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PRODUCT_NAME')}}*</label>
                                    <input type="text" v-model="name" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PRODUCT_CODE')}}</label>
                                    <input type="text" v-model="code" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('BRAND')}}</label>
                                    <input type="text" v-model="brand" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('MODEL')}}</label>
                                    <input type="text" v-model="model" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('DESCRIPTION')}}</label>
                                    <input type="text" v-model="description" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('TAX')}}</label>
                                    <input type="text" v-model="tax" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex align-items-end">
                                        <div class="col-11 p-0">   
                                            <div class="d-flex justify-content-between">
                                                <label class="new-label">{{$ml.get('PRODUCT_PRICE')}}</label>
                                                <label class="new-label">{{$ml.get('CURRENCY')}}</label>
                                            </div> 
                                            <div class="mb-2" v-for="price in prices">
                                                <div class="input-dropdown currencyArea d-flex">
                                                    <input type="text" v-model.number="price.price" class="new-input">
                                                    <div class="dropdown-button bg-new-gray col-3 p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <div>{{currencyLabel(price.currency)}}</div>
                                                    </div>
                                                    <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0 border-0">
                                                        <ul>
                                                            <template v-for="cur in currencyTitle" :key="cur && cur.value"><li v-if="cur && !cur.disabled" @click="price.currency=cur.value,changeCurrency(cur.value)">{{cur.label}}</li></template>
                                                        </ul>
                                                    </div>
                                                    <!--<div class="bg-new-gray col-3 p-0">
                                                        <v-select :options="currencyTitle" :reduce="label => label.value" label="label" v-model="price.currency" @input="changeCurrency" :searchable="false"/>
                                                    </div>-->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-1 d-flex align-items-center h-36 mb-2" v-if="addPriceButton"><i class="fa fa-plus font-md light-gray-color cursor-pointer" @click="addPriceDom"></i></div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PASSIVE')}} / {{$ml.get('ACTIVE')}}</label>
                                    <div class="d-flex align-items-center">
                                        <label class="switch heightSwitch m-0">
                                        <input type="checkbox"  v-model="status">
                                        <span class="slider round true"></span>
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade py-2" id="customField" role="tabpanel" aria-labelledby="customField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" :edit="listenStateStatus" :editArray="$store.state.editLine" @returnCustomData="returnCustomData($event)" postField="product" :user="user" :users="users" @returnCustomField="returnCustomField=$event" :customField="customFieldArray" :allcustomFieldArray="customFieldArray"></special-area>
                    </div>
                </div>
            </div>
          
        </div>
        <div class="row crm-modal-footer stickyBtn mx-0">
            <hr class="col-12 p-0 d-none mt-0 d-md-block">
            <div class="col-12 dealBtnStyle pb-3" v-if="listenStateStatus===false">
                <div class="row">
                    <!-- <div class="col-6">
                        <button @click="closeButton" class="btn-new w-100">{{$ml.get('CANCEL')}}</button>
                    </div> -->
                    <div class="col-12">
                        <button @click="saveButton" class="btn-new save  ml-2 d-flex justify-content-center align-items-center">{{$ml.get('SAVE')}}</button>
                        <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                    </div>
                </div>
            </div>
            <div class="col-12 dealBtnStyle pb-3" v-if="this.listenStateStatus">
                <div class="row">
                    <!-- <div class="col-6">
                        <button @click="closeButton" class="btn-new w-100">{{$ml.get('CANCEL')}}</button>
                    </div> -->
                    <div class="col-12"> 
                        <button @click="saveButton" data-dismiss="modal" class="btn-new save ml-2 d-flex justify-content-center align-items-center">{{$ml.get('EDIT')}}</button>
                         <button @click="closeButton" class="btn-new ">{{$ml.get('CANCEL')}}</button>
                    </div>
                </div>
            </div>
        </div>
             <!-- Değişiklik uyarısı Modal -->
        <div class="modal fade h-100" id="changeAlertModalProduct" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white" >
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal" @click="changeAlertModalCancel">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="saveButton">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
import _ from 'underscore'
import specialArea from '@/components/customField'
export default {
    name: 'newProduct',
    props:["customFieldArray","user","users","clearModal"],
    components:{
        'special-area':specialArea,
    },
        
    data () {
        return {
            returnCustomField:[],
            name:"",
            status:true,
            code:"",
            brand:"",
            model:"",
            description:"",
            tax:"",
            currency:0,
            updateProductId:"",
            updateData:{},
            prices:[
                {price:'',currency:parseInt(localStorage.defaultCurrency)}
            ],
            addPriceButton:true
        }
    },
    computed: {
        ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu'
        ]),
        listenState() { return this.$store.state.editLine },
        listenStateStatus() { return this.$store.state.editLineStatu },
        currencyTitle(){
            return this.currencyData().map(c => {
                if(c.id==localStorage.defaultCurrency){
                    c['disabled']=true
                }else{
                    c['disabled']=false
                }
                c['value'] = parseInt(c.id)
                return c
            });
        }
    },
    methods:{
        returnCustomData(data){
            data['edit']=true
            this.$store.dispatch('editLine', data)
        },

        saveButton(){

            let dataObj={}
            let obj={}
            let url=""
            if(this.name===""){
                this.$notify({ group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('PRUDUCT_NAME_CANNOT_BE_BLANK'),
                    text: this.$ml.get('PLEASE_ENTER_A_PRODUCT_NAME') })
                    setTimeout(() => {
                        $(".crm-modal-body").css("display","block")
                        $(".crm-modal-header").css("position","sticky")
                        $(".crm-modal-footer").css("display","flex")
                        $(".crm-modal-content").css("width","100% ")
                    }, 300);
                return false
            }
            obj["name"]=this.name
            if(this.code!=="" && this.code!==null){
                obj["code"]=this.code
            }
            if(this.brand!=="" && this.brand!==null){
                obj["brand"]=this.brand
            }
            if(this.model!=="" && this.model!==null){
                obj["model"]=this.model
            }
            if(this.description!=="" && this.description!==null){
                obj["description"]=this.description
            }
            if(this.tax!=="" && this.tax!==null){
                obj["tax"]=parseInt(this.tax) 
            }
            if(this.status!==null){
                obj["status"]=this.status
            }

            if(this.prices[0].price!=="" && this.prices[0].price!==null){
                    obj["prices"]=this.prices
            }

            for (var customId in this.returnCustomField){
                if (typeof this.returnCustomField[customId] !== 'function') {
                    obj[customId] = this.returnCustomField[customId]
                }
            }

            if(this.listenStateStatus===false){
                url = "addProduct"
                dataObj["productInputObj"]=obj
                this.postProduct(url,dataObj)
            }else{
                url = "updateProduct"
                dataObj["objId"]=this.updateProductId
                dataObj["updateObj"]=obj
                this.postProduct(url,dataObj)
                if(this.$route.path==="/reports"){
                    setTimeout(() => {
                        this.$root.$refs.groupBuilder.sendQuery() 
                    }, 1000);
                   
                }
            }
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
        },
        changeAlertModalCancel(){
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
          
        },
         closeButton(){
            if(
                this.name=="" && 
                this.code=="" && 
                this.brand=="" && 
                this.model=="" && 
                this.description=="" && 
                this.tax=="" &&
                this.status==true && 
                this.priceValue==""
                 ){

                      $("#add").modal("hide")
                      this.clear()
            }
            else{
                    $(".crm-modal-body").css("display","none")
                    $(".crm-modal-header").css("position","absolute ")
                    $(".crm-modal-footer").css("display","none ")
                    $(".crm-modal-content").css("width","0 ")
                    $('#changeAlertModalProduct').modal('show')
            }  
        },
        clear(){
            this.name="",
            this.code="",
            this.brand="",
            this.model="",
            this.description="",
            this.tax="",
            this.status=true,
            this.currency=0,
            this.price="",
            this.prices=[
                {currency:parseInt(localStorage.defaultCurrency),price:''}
            ],
            this.$store.state.editLine={},
            this.addPriceButton=true


            setTimeout(() => {
            this.$refs.customFields.clearCustom();
            }, 0);
        },
        permissionSet(){
            if(this.user.userRoleId===2){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        changeCurrency(event){
            for(var c in this.currencyTitle){
                this.currencyTitle[c].disabled=false
                for(var p in this.prices){
                    if(this.prices[p].currency==this.currencyTitle[c].value){
                        this.currencyTitle[c].disabled=true
                    }
                }
            }
        },
        addPriceDom(){
            if(this.currencyTitle.find(c=>c.disabled==false)!==undefined){
                var nextCurrency=this.currencyTitle.find(c=>c.disabled==false).value
                this.prices.push({currency:nextCurrency,price:''})
            }else{
                this.addPriceButton=false
            }
            for(var c in this.currencyTitle){
                this.currencyTitle[c].disabled=false
                for(var p in this.prices){
                    if(this.prices[p].currency==this.currencyTitle[c].value){
                        this.currencyTitle[c].disabled=true
                    }
                }
            }
            if(this.currencyTitle.find(c=>c.disabled==false)==undefined){
                this.addPriceButton=false
            }
            
        },
        postProduct(url,obj){
            if(this.permissionSet()){
                return false
            }
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){

                    if(this.listenStateStatus===false){
                        Object.keys(this.returnCustomField).forEach(key => {
                            delete this.returnCustomField[key];
                        })
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('PRODUCT_ADDED'),
                            text: res.data.status.desc 
                        })
                    }else{

                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('PRODUCT_HAS_BEEN_UPDATED'),
                            text: res.data.status.desc 
                        })

                    }
                    
                    $('#add').modal('hide')
                    this.clear()
                    this.$emit('getData',res.data.content.product)
                     
                }else{
                    if(res.data.status.code==136){
                        var details=this.$ml.get('CODE_FIELD_MUST_BE_UNIQUE')
                    }else{               
                        var details=res.data.status.desc 
                    }
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: 'Hata!',
                        text: details
                    })
                     
                }
            })
        },
        dataFilling(updateData){
            
            if(!this.isEmpty(updateData)){
                
                if(updateData.edit){
                    if(updateData.name!==undefined){
                        this.name=updateData.name
                    }

                    if(updateData.code!==undefined){
                        this.code=updateData.code
                    }

                    if(updateData.brand!==undefined){
                        this.brand=updateData.brand
                    }
                    if(updateData.model!==undefined){
                        this.model=updateData.model
                    }
                    if(updateData.description!==undefined){
                        this.description=updateData.description
                    }
                    if(updateData.tax!==undefined){
                        this.tax=updateData.tax.val
                    }
                    if(updateData.status!=null){
                        this.status=updateData.status
                    }else{
                        this.status=true
                    }
                    if(updateData.prices!=undefined){
                        this.prices=updateData.prices
                    }

                    if(updateData._id.$oid!==undefined){
                        this.updateProductId=updateData._id.$oid
                    }
                }else{
                    if(updateData.name.val!==undefined){
                        this.name=updateData.name.val
                    }

                    if(updateData.code.val!==undefined){
                        this.code=updateData.code.val
                    }

                    if(updateData.brand.val!==undefined){
                        this.brand=updateData.brand.val
                    }
                    if(updateData.model.val!==undefined){
                        this.model=updateData.model.val
                    }
                    if(updateData.description.val!==undefined){
                        this.description=updateData.description.val
                    }
                    if(updateData.tax!==undefined){
                        this.tax=updateData.tax.val
                    }
                    if(updateData.status.val!=null){
                        this.status=updateData.status.val
                    }else{
                        this.status=true
                    }
                    if(updateData.prices.val!=undefined){
                        this.prices=updateData.prices.val
                    }

                    if(updateData._id.val.$oid!==undefined){
                        this.updateProductId=updateData._id.val.$oid
                    }
                }

            }
        },
        isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        },
        ...mapActions([
            'updateLoading'
        ]),
        activaTabProduct(){
            console.log("activaTab çalıştı");
            // $('#newActivityTabMenu a[href="#' + "'activityA_'+parentComp" + '"]').tab('show');
            // activaTab("'activityA_'+parentComp")
              $('.mincrm-dynamic-tabs a[href="#' + 'product' + '"]').tab('show');
        },
    },
    watch: {
        listenState(data) {
            this.dataFilling(data)
        },
        listenStateStatus(data){
            if(data===false){
                this.$store.state.editLine=[]
                this.clear()
            }
        },
        clearModal:function(){
            this.clear()
        }
    },
    created(){
        this.$root.$refs.newProduct=this
    },
    mounted(){
        $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-header{
    position: sticky;
    top: 0;
    z-index: 1;
}
label{
    margin-bottom: 4px;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>
